module.exports = __webpack_public_path__ + "img/in-house.f39ebc60.png";